import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
export var getQuantityMap = function(params) {
    var quantityString = params.get("quantityMap");
    if (!quantityString) {
        return undefined;
    }
    var quantityMap = new Map();
    quantityString.split(",").forEach(function(pair) {
        var _pair_split = _sliced_to_array(pair.split(":"), 2), key = _pair_split[0], value = _pair_split[1];
        if (key && value) {
            quantityMap.set(key, parseInt(value, 10));
        }
    });
    return quantityMap;
};
